import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, staffRegister, title = 'Staff Register') => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(staffRegister, title),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: title,
            }
        }

        pushIntoTable(doc, staffRegister)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (staffRegister, title = 'Staff Register') => {
        return [
            {
                text:  title,
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: [ '6%', '15%', '23%', '23%', '23%', '10%' ]
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const pushIntoTable = (doc, staffRegister) => {
        const tableItems = staffRegister;
        const tableHeader = getTableHeader();
        doc.content[1].table.body.push(tableHeader);

        tableItems.forEach((item, index) => {
            const rowData = getRowData(item, index + 1);
            return doc.content[1].table.body.push(rowData);
        });
    }

    const getTableHeader = () => {
        const tableHeader = [
            {text: '#SL'},
            {text: 'Staff ID'},
            {text: 'Staff Name'},
            {text: 'Ref. Name & ID'},
            {text: 'Rank'},
            {text: 'Generation'},
        ]

        return tableHeader
    }
    const getRowData = (item = {}, sl = 1) => {
        const tableRow = [
            { text: sl },
            { text: item.serial_no },
            { text: item.name },
            { text: item.parent_name + `(${item.parent_serial_no})` },
            { text: item.incentive_setup_name + `(${item.incentive_equivalent_designation})` },
            { text: item.level },
        ];

        return tableRow;
    };

    return {
        exportToPDF
    }

}

export default pdfPrinter;